<script setup lang="ts"></script>
<template>
    <div
        class="bg-gray-lightest rounded-full overflow-hidden relative min-h-10 h-full w-auto aspect-square"
    >
        <img
            src="../../img/ai-buddy.png"
            alt="AI Buddy Icon"
            class="absolute -top-1/10 -left-1/5 min-w-[145%] h-[145%] scale-x-[-1]"
        />
    </div>
</template>
